import { CommonFunctions } from "../static/common-functions";

export class Address 
{
    constructor(data: Address = null)
    {
        if (data !== null) {
            this.set(data.addressLine1, data.addressLine2, data.city, data.stateProvince, data.postalCode, data.locationName, data.addressType);
        }
    }
    set(addressLine1: string, addressLine2: string, city: string, stateProvince: string, postalCode: string, locationName: string = null, addressType: string = null) {
        this.addressLine1 = addressLine1;
        this.addressLine2 = addressLine2;
        this.city = city;
        this.stateProvince = stateProvince;
        this.postalCode = postalCode;
        this.locationName = locationName;
        this.addressType = addressType;
        this.cityStateZip = CommonFunctions.cityStateZip(this.city, this.stateProvince, this.postalCode);
    }
  addressType: string;
  locationName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  cityStateZip: string; 
  get hasAddressLine2(): boolean {
      return CommonFunctions.hasStringValue(this.addressLine2);
  } 
  get hasAddressType(): boolean {
        return CommonFunctions.hasStringValue(this.addressType);
  } 
}